import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { translate } from '../../../../utils/util';
import { Preloader } from '../../../../components/UI/ComponentsUI';
import M from 'materialize-css/dist/js/materialize';

const ErrorSummary = (props) => {
    const [info, setInfo] = useState({ totalErrors: 0, fullLocation: 0, nonExistingCIM: 0, nonExistingPlace: 0, others: 0, pallet: 0, preciousMaterial: 0, quality: 0, reserved: 0, preloader: true });
    const [, setInstanceM] = useState();

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: true,
        });
        setInstanceM(instance);
        if (props.data.length > 0) {
            getSummaryErrors();
        }
        // eslint-disable-next-line
    }, [props.data]);

    const getSummaryErrors = () => {
        props.getSummaryErrors({
            success: false,
            updated: false,
            PageIndex: 0
        }, (response) => {
            setInfo({
                ...response,
                preloader: false
            });
        });
    };


    return (
        <div className="card" style={{ marginLeft: '24px', marginRight: '24px' }}>
            <ul id='collapsible' className="collapsible summary">
                <li>
                    <div className="collapsible-header" style={{ padding: '3px' }}>
                        <div className="flex-center" >
                            <i className={`mdi mdi-file-document-alert left`} style={{ fontSize: '20px', marginTop: '-4px' }} />
                            <b>{translate('open-errors', 'change-location')}: {info.totalErrors}</b>
                        </div>
                    </div>
                    <div className="collapsible-body" style={{ padding: '10px' }}>
                        {
                            info.preloader ? <Preloader /> : <>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.non-existing-cim', 'change-location')}: {info.nonExistingCIM}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.non-existing-place', 'change-location')}: {info.nonExistingPlace}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.reserved', 'change-location')}: {info.reserved}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.quality', 'change-location')}: {info.quality}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.precious-material', 'change-location')}: {info.preciousMaterial}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.pallet', 'change-location')}: {info.pallet}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.full-location', 'change-location')}: {info.fullLocation}</i>
                                <i className="sixth-text-color" style={{ display: 'block' }}>{translate('summary-errors.others', 'change-location')}: {info.others}</i>
                            </>
                        }
                    </div>

                </li>
            </ul >
        </div>
    );

}
const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSummaryErrors: (filter, callback) => {
            dispatch(ChangeLocationService.getSummaryErrors(filter, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ErrorSummary)));